import { useContext, useEffect, useState } from "react";
import "./index.scss";
import { UserContext } from "../context/userContext";
import { toast } from "react-toastify";
import editProfilePhoto from "../../services/edit-profile-photo";
import { useNavigate } from "react-router-dom";
import Lottie from "react-lottie";
import { defaultOptionsLoading } from "../../assets/lottie-animations/animationOptions";

const ModalEditPhoto = ({ closeModal }) => {
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const { user } = useContext(UserContext);
  const [selectedImage, setSelectedImage] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState<any>(null);
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let file = event.target.files[0];
    if (Boolean(file)) {
      setSelectedImage(file);
    }
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (Boolean(selectedImage)) {
      setImageUrl(URL?.createObjectURL(selectedImage));
    }
  }, [selectedImage]);

  const savePhoto = async () => {
    setLoading(true);
    await sleep(2000);
    var formData = new FormData();
    formData.append("photo", selectedImage);
    var data = { photo: selectedImage };

    editProfilePhoto(data, user?._id)
      .then((response: any) => {
        setLoading(false);
        if (response?.data?.status === 500) {
          toast.error("Internal server error!");
          return;
        }
        // if (!response?.data?.success) {
        //   toast.error(response?.error);
        //   return;
        // }
        if (response?.data?.success) {
          toast.success("image uploaded successfuly !");
          closeModal();
          navigate("/acceuil");
        }
      })
      .catch((error) => {
        setLoading(false);

        toast.error("Internal server error !");
      });
  };

  return (
    <div className="modal-container">
      {loading ? (
        <Lottie
          options={defaultOptionsLoading}
          style={{ height: 150, width: 150 }}
        />
      ) : (
        <>
          <div className="modal-header">
            <span className="choose-pdp-txt">Ajouter une photo</span>
            <i
              className="bx bx-x"
              style={{ fontSize: 22, fontWeight: "700" }}
              onClick={() => closeModal()}
            ></i>
          </div>
          <div className="modal-body">
            {selectedImage ? (
              <div
                style={{
                  height: "90%",
                  width: "80%",
                  display: "flex",
                  flexDirection: "row",
                  boxShadow: `box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.05)`,
                  borderRadius: 6,
                }}
              >
                <div className="upload-file-content-img-selected">
                  <img
                    src={imageUrl}
                    alt="Selected"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div style={{ height: 80, width: "15%", marginLeft: 10 }}>
                  <div className="custom-file-upload">
                    <input
                      type="file"
                      id="file-upload"
                      accept=".jpg,.gif,.png"
                      multiple
                      onChange={handleFileChange}
                    />
                    <label
                      style={{
                        borderRadius: 6,
                        backgroundColor: "#FFF",
                        boxShadow: `0px 4px 16px 0px rgba(0, 0, 0, 0.05)`,
                        color: "#159B7B",
                        borderWidth: 0,
                      }}
                      htmlFor="file-upload"
                    >
                      <i
                        style={{
                          fontSize: 25,
                          color: "#000",
                          marginRight: 10,
                        }}
                        className="bx bx-repost"
                      ></i>
                    </label>
                  </div>

                  <div
                    style={{
                      marginTop: 10,
                      height: 35,
                      width: "110%",
                      backgroundColor: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: 6,
                    }}
                    onClick={() => setSelectedImage(null)}
                  >
                    <i
                      style={{
                        fontSize: 25,
                        color: "#000",
                        marginRight: 10,
                      }}
                      className="bx bx-trash"
                    ></i>
                  </div>
                </div>
              </div>
            ) : (
              <div className="upload-file-content">
                {selectedImage ? (
                  <div style={{ width: "100%", height: "100%" }}>
                    <img
                      src={imageUrl}
                      alt="Selected"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        textAlign: "center",
                        alignSelf: "center",
                      }}
                    />
                  </div>
                ) : (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <i
                      onClick={closeModal}
                      style={{
                        fontSize: 50,
                        color: "#787878",
                        marginBottom: 10,
                        alignSelf: "center",
                        display: "flex",
                        textAlign: "center",
                      }}
                      className="bx bx-image"
                    ></i>
                    <p
                      style={{
                        color: "#787878",
                        fontSize: 12,
                        fontWeight: 400,
                        textAlign: "center",
                        marginBottom: 10,
                      }}
                    >
                      jpg.png.pdf.doc
                    </p>

                    <div className="custom-file-upload">
                      <input
                        type="file"
                        id="file-upload"
                        accept=".jpg,.gif,.png"
                        multiple
                        onChange={handleFileChange}
                      />
                      <label
                        style={{
                          borderRadius: 6,
                          backgroundColor: "#FFF",
                          boxShadow: `0px 4px 16px 0px rgba(0, 0, 0, 0.05)`,
                          color: "#159B7B",
                          borderWidth: 0,
                        }}
                        htmlFor="file-upload"
                      >
                        Upload
                      </label>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button className="cancel-btn" onClick={() => closeModal()}>
              Cancel
            </button>
            <button className="save-btn" onClick={() => savePhoto()}>
              Save
            </button>
          </div>
        </>
      )}
    </div>
  );
};
export default ModalEditPhoto;
function sleep(arg0: number) {
  throw new Error("Function not implemented.");
}
